import React from "react";
import styled from "styled-components";

const NutritionFactsTab = () => {
  return (
    <div className="max-w-[360px] border border-black mx-auto p-2 text-[12px]">
      <div>
        <div className="title text-[32px] text-black font-bold pb-1">
          <h2>Nutrition Facts</h2>
        </div>
        <div className="desc text-sm pb-1">
          <p>Serving Size 1/2 cup (about 82g)</p>
          <p>Serving Per Container 8</p>
        </div>
        <div className="border-t-8 border-b-2 border-black mb-2"></div>
        <Table>
          <thead className="text-[13px] border-b border-black text-left">
            <tr className="">
              <th colSpan={3} className="font-normal">
                Amount Per Serving
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-black">
              <td className="font-bold  border-b-4 border-black">Calories</td>
              <td className="border-b-4 border-black">200g</td>

              <td className="font-normal text-right border-b-4 border-black">
                Calories from Fat 130
              </td>
            </tr>
            <tr className="thick font-bold text-black text-right">
              <td colSpan={3}>% Daily Value*</td>
            </tr>
            <tr className="text-black">
              <td className="font-bold">Total Fat</td>
              <td>14g</td>
              <td className="font-bold text-right">22%</td>
            </tr>
            <tr className="text-black ">
              <td className=" pl-4">Saturated Fat</td>
              <td>14g</td>
              <td className="font-bold text-right">22%</td>
            </tr>
            <tr className="text-black ">
              <td className=" pl-4">Trans Fat</td>
              <td>0g</td>
              <td className="font-bold text-right">22%</td>
            </tr>
            <tr className="text-black">
              <td className="font-bold">Total Carbohydrate</td>
              <td>14g</td>
              <td className="font-bold text-right">22%</td>
            </tr>
            <tr className="text-black ">
              <td className=" pl-4">Saturated Carbohydrate</td>
              <td>14g</td>
              <td className="font-bold text-right">22%</td>
            </tr>
            <tr className="text-black ">
              <td className=" pl-4">Trans Carbohydrate</td>
              <td>0g</td>
              <td className="font-bold text-right">22%</td>
            </tr>
            <tr className="text-black">
              <td className="font-bold">Protein</td>
              <td>14g</td>
            </tr>
          </tbody>
        </Table>
        <div className="border-t-8 border-b-2 border-black mb-2"></div>
        <Table>
          <tbody className="text-base text-black">
            <tr>
              <td colSpan={2}>Vitamin A 10%</td>
              <td className="before:content-['•'] before:font-bold before:mr-1">
                Vitamin C 0%
              </td>
            </tr>
            <tr>
              <td colSpan={2}>Calcium 10%</td>
              <td className="before:content-['•'] before:font-bold before:mr-1">
                Iron 6%
              </td>
            </tr>
          </tbody>
        </Table>
        <p className="note text-[11px] text-[#8b8b8b]">
          * Percent Daily Values are based on a 2,000 calorie diet. Your daily
          values may be higher or lower depending on your calorie needs:
        </p>
        <table className="border-collapse border-b border-black text-[11px] text-black w-full">
          <thead className="border-collapse border-b border-black">
            <tr className="">
              <th colSpan={1}></th>
              <th className="font-normal text-left">Calories:</th>
              <th className="font-normal text-left">2,000</th>
              <th className="font-normal text-left">2,500</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Total Fat</td>
              <td>Less than</td>
              <td>65g</td>
              <td>80g</td>
            </tr>
            <tr>
              <td className="pl-4">Saturated Fat</td>
              <td>Less than</td>
              <td>65g</td>
              <td>80g</td>
            </tr>
            <tr>
              <td>Total Carbohydrate</td>
              <td></td>
              <td>65g</td>
              <td>80g</td>
            </tr>
          </tbody>
        </table>
        <p className="note text-[11px] text-[#8b8b8b]">Calories per gram:</p>
        <p className="note text-[11px] text-[#8b8b8b] text-center">
          Fat 9 • Carbohydrate 4 • Protein 4
        </p>
      </div>
    </div>
  );
};

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-bottom: 1px solid black;
  margin-bottom: 8px;
  & tr {
    border-bottom: 1px solid black;
    border-collapse: collapse;
  }
`;

export default NutritionFactsTab;
